import React from "react";
import close from "../../../assets/Images/icons/Cancel.svg";
import Switch from "react-switch";

const AddPartnerModal = ({
  isOpen,
  onClose,
  partnerName,
  onPartnerNameChange,
  addPartnerStatus,
  onAddPartnerStatusChange,
  loading,
  onSave,
}) => {
  return (
    <div className={(isOpen ? "modal fade show" : "modal fade") + " custom-modal modal-backdrop"}>
      <div className="modal">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Enter Our Partner</h5>
              <img src={close} alt="" className="mx-2" role="button" onClick={onClose} />
            </div>
            <div className="modal-body">
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Name"
                value={partnerName}
                onChange={(e) => onPartnerNameChange(e.target.value)}
              />
              <div className="d-flex align-items-center gap-2">
                <span className="me-2">Status</span>
                <Switch
                  checked={addPartnerStatus === 1}
                  onChange={(checked) => onAddPartnerStatusChange(checked ? 1 : 0)}
                  className="react-switch"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  offColor="#D9D9D9"
                  onColor="#7589EC"
                />
                <span style={{ color: addPartnerStatus === 1 ? "#7589EC" : "#666" }}>
                  {addPartnerStatus === 1 ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className={(loading ? "disabled" : "") + " btn btn-primary"}
                onClick={onSave}
              >
                Save
              </button>
              <button
                type="button"
                className={(loading ? "disabled" : "") + " btn btn-secondary"}
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPartnerModal;
